import {
    GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_FAILED, GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_LOADING, GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_SUCCESS, REMOVE_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES
} from "../types";

const initialState = {
    CurrentPreviousMonth: null,
    loading: null,
    error: null,
};

export const getMerchantCurrentPreviousReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                CurrentPreviousMonth: action.payload,
            };
        case GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES:
            return initialState;

        default:
            return state;
    }
};
